var React = require('react');

function CurveMask (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"fillOpacity":"1","d":"M 0 2 L 120 18 C 240 34 480.491 45.942 720.491 45.942 C 960.491 45.942 1200 34 1320 18 L 1440 2 L 1439.824 102.918 L 1439.853 300.821 C 1319.853 300.821 954.778 299.986 714.778 299.986 C 474.778 299.986 119.089 301.251 -0.911 301.251 L -1.014 102.995 L 0 2 Z","key":1})]);
}

CurveMask.defaultProps = {"viewBox":"0 0 1440 300"};

module.exports = CurveMask;

CurveMask.default = CurveMask;
